import React, { memo } from 'react';
import { Box, Button, Collapse, Stack } from '@mui/material';
import DataObject from "@mui/icons-material/DataObject";
import FileUploadIcon from "@mui/icons-material/FileUpload";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import styled from '@emotion/styled';
import CodeEditor from '../monacoEditor';

const VisuallyHiddenInput = styled("input")({
  clip: "rect(0 0 0 0)",
  clipPath: "inset(50%)",
  height: 1,
  overflow: "hidden",
  position: "absolute",
  bottom: 0,
  left: 0,
  whiteSpace: "nowrap",
  width: 1,
});

const commonStyles = {
  bgcolor: "background.paper",
  m: 1,
  border: 1,
  width: "60rem",
  height: "39rem",
};

const SecretEditor = memo(({
  openCreate,
  openUpload,
  selectedFile,
  jsonInput,
  fileContent,
  onCreateClick,
  onUploadClick,
  onFileChange,
  onCodeChange,
  onCreateSecret,
  onCancel,
}) => {
  return (
    <Box sx={{ width: "100%", display: "flex", flexDirection: "column", alignItems: "center", my: 3 }}>
      <Stack direction="row" spacing={2}>
        <Button
          disabled={openCreate || openUpload || selectedFile}
          variant="outlined"
          onClick={onCreateClick}
          startIcon={<DataObject />}
        >
          Input values
        </Button>
        <Button
          disabled={openCreate || openUpload || selectedFile}
          variant="outlined"
          onClick={onUploadClick}
          startIcon={<FileUploadIcon />}
        >
          Upload file
        </Button>
      </Stack>

      <Collapse in={openUpload}>
        <Box sx={{ ...commonStyles, flexDirection: "column", borderColor: "grey.300", justifyContent: "center", alignItems: "center", display: "flex", borderRadius: "1%", width: "50rem" }}>
          <Box component="div" sx={{ my: 2, p: 1, bgcolor: "grey.100", border: "1px solid", borderColor: "grey.300", borderRadius: 2, width: "80%", height: "60%", display: "flex", justifyContent: "center", alignItems: "center" }}>
            <Button component="label" variant="contained" size="large" startIcon={<CloudUploadIcon />}>
              Click to upload file
              <VisuallyHiddenInput type="file" accept=".json" onChange={onFileChange} />
            </Button>
          </Box>
        </Box>
      </Collapse>

      <Collapse in={selectedFile || openCreate}>
        <Box sx={{ ...commonStyles, flexDirection: "column", borderColor: "grey.300", justifyContent: "space-between", display: "flex", borderRadius: "1%" }}>
          <Box sx={{ display: "flex", justifyContent: "flex-end", alignItems: "center", height: "2.5rem", borderBottom: 1, bgcolor: "grey.100", borderColor: "grey.300" }}></Box>
          
          <div style={{ display: "flex", justifyContent: "center" }}>
            <Box component="div" sx={{ my: 2, p: 1, bgcolor: "grey.100", border: "1px solid", borderColor: "grey.300", borderRadius: 2, width: "55rem", height: "30rem", display: "flex", justifyContent: "center" }}>
              <div style={{ overflow: "auto" }}>
                <CodeEditor
                  language="json"
                  value={selectedFile ? fileContent : jsonInput}
                  onChange={onCodeChange}
                  selectedTheme="vs-dark"
                  readOnly="false"
                />
              </div>
            </Box>
          </div>
          
          <Box sx={{ display: "flex", justifyContent: "flex-end", alignItems: "center", height: "2.5rem", bgcolor: "grey.100", borderColor: "grey.300" }}>
            <Button sx={{ textTransform: "capitalize", px: 3 }} onClick={onCreateSecret}>
              Create
            </Button>
            <Button variant="neutral" sx={{ textTransform: "capitalize", px: 3, ml: 2, mr: 5 }} onClick={onCancel}>
              cancel
            </Button>
          </Box>
        </Box>
      </Collapse>
    </Box>
  );
});

SecretEditor.displayName = 'SecretEditor';
export default SecretEditor;